import React from 'react';

// Palette de couleurs prédéfinies — cliquez pour sélectionner rapidement
export const COLOR_PRESETS = [
  { value: '#ef4444', label: 'Rouge — Urgent' },
  { value: '#f97316', label: 'Orange — Important' },
  { value: '#f59e0b', label: 'Ambre' },
  { value: '#eab308', label: 'Jaune' },
  { value: '#84cc16', label: 'Vert clair' },
  { value: '#10b981', label: 'Vert — Terminé' },
  { value: '#14b8a6', label: 'Turquoise' },
  { value: '#06b6d4', label: 'Cyan' },
  { value: '#3b82f6', label: 'Bleu — Client' },
  { value: '#6366f1', label: 'Indigo' },
  { value: '#8b5cf6', label: 'Violet' },
  { value: '#ec4899', label: 'Rose' },
  { value: '#64748b', label: 'Gris' },
  { value: '#1e293b', label: 'Noir' },
];

export default function ColorPicker({ value, onChange, label = 'Couleur' }) {
  return (
    <div className="form-group">
      <label>{label}</label>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
        {/* Bouton "Aucune couleur" */}
        <button
          type="button"
          onClick={() => onChange('')}
          title="Aucune couleur (défaut)"
          style={{
            width: 28, height: 28, borderRadius: 8,
            border: !value ? '2px solid var(--primary)' : '2px solid var(--border)',
            background: 'white',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '0.85rem',
            color: 'var(--text-light)',
            padding: 0,
          }}
        >
          ∅
        </button>

        {/* Presets */}
        {COLOR_PRESETS.map(c => (
          <button
            key={c.value}
            type="button"
            onClick={() => onChange(c.value)}
            title={c.label}
            style={{
              width: 28, height: 28, borderRadius: 8,
              background: c.value,
              border: value === c.value ? '3px solid var(--text)' : '2px solid white',
              boxShadow: '0 0 0 1px var(--border)',
              cursor: 'pointer',
              padding: 0,
              transition: 'transform 0.15s',
              transform: value === c.value ? 'scale(1.1)' : 'scale(1)',
            }}
          />
        ))}

        {/* Couleur libre (color picker natif) */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 4 }}>
          <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Autre :</span>
          <input
            type="color"
            value={value || '#6366f1'}
            onChange={e => onChange(e.target.value)}
            style={{ width: 32, height: 28, border: '1px solid var(--border)', borderRadius: 6, cursor: 'pointer', padding: 2 }}
          />
        </div>
      </div>
      {value && (
        <div style={{ fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 4 }}>
          Couleur sélectionnée : <span style={{ display: 'inline-block', width: 10, height: 10, background: value, borderRadius: 2, verticalAlign: 'middle' }} /> {value}
        </div>
      )}
    </div>
  );
}
